import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { useTranslation } from '@/i18n';
import { useUI } from '@/hooks/ui/useUI';
import { ROUTE_DEFINITIONS } from '@/routes';
import { useMonthlyCutDateRangeLookup } from './useMonthlyCutDateRangeLookup';


export interface UseMonthSummaryAbsencesDetailNavigationResult {
  navigateToDetail: () => Promise<void>;
}

// Data hook for the "Resumen del mes" dashboard "Ausencias" card "Detalle" action
// (ASIS-5398 / REXASIS-007). Redirects to "Resumen ausentismos" with the date range of the
// cutoff selected in the dashboard, forcing the type filter to "Todos" per the ticket's
// acceptance criteria.
export function useMonthSummaryAbsencesDetailNavigation(
  selectedCompanyId: string,
  selectedCutId: string,
): UseMonthSummaryAbsencesDetailNavigationResult {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  const { showNotification, showApiError } = useUI();
  const { resolveDateRange } = useMonthlyCutDateRangeLookup();

  const navigateToDetail = useCallback(async () => {
    const { range, response } = await resolveDateRange(selectedCompanyId, selectedCutId);
    if (!range) {
      const fallback = translate('attendance:dashboard.monthSummary.ausencias.menu.loadError');
      if (response) {
        showApiError(response, fallback);
      } else {
        showNotification('error', fallback, 5000);
      }
      return;
    }
    void navigate(
      `${ROUTE_DEFINITIONS.RESUMEN_AUSENTISMOS.path}?from=${range.from}&to=${range.to}`,
    );
  }, [
    navigate, resolveDateRange, selectedCompanyId, selectedCutId,
    showApiError, showNotification, translate,
  ]);

  return { navigateToDetail };
}

export default useMonthSummaryAbsencesDetailNavigation;
